import { axiosGet } from "../../app/Helpers/AxiosHelper";

export default {

    state: {
        locationList: [],
        bankList: [],
        departmentList: [],
        categoryList: [],
        workingShiftList: [],
        employeeList: [],
        leaveTypeList: [],
        jobTitleList: [],
        payrollPeriodList: [],
    },

    getters: {
        getLocationList: state => state.locationList,
        getBankList: state => state.bankList,
        getDepartmentList: state => state.departmentList,
        getCategoryList: state => state.categoryList,
        getWorkingShiftList: state => state.workingShiftList,
        getEmployeeList: state => state.employeeList,
        getLeaveTypeList: state => state.leaveTypeList,
        getJobTitleList: state => state.jobTitleList,
        getPayrollPeriodList: state => state.payrollPeriodList,
    },

    actions: {
        getLocations({ commit }) {
            const url = '/support/locations';
            axiosGet(url).then(res => {
                commit('SET_LOCATIONS', res.data);
            });
        },
        getBanks({ commit }) {
            const url = '/support/banks';
            axiosGet(url).then(res => {
                commit('SET_BANKS', res.data);
            });
        },
        getDepartments({ commit }) {
            const url = '/support/departments';
            axiosGet(url).then(res => {
                commit('SET_DEPARTMENTS', res.data);
            });
        },
        getCategories({ commit }) {
            const url = '/support/categories';
            axiosGet(url).then(res => {
                commit('SET_CATEGORIES', res.data);
            });
        },
        getWorkingShifts({ commit }) {
            const url = '/support/working-shifts';
            axiosGet(url).then(res => {
                commit('SET_WORKING_SHIFTS', res.data);
            });
        },
        getEmployees({ commit }) {
            const url = '/support/employees';
            axiosGet(url).then(res => {
                commit('SET_EMPLOYEES', res.data);
            });
        },
        getLeaveTypes({ commit }) {
            const url = '/support/leave-types';
            axiosGet(url).then(res => {
                commit('SET_LEAVE_TYPES', res.data);
            });
        },
        getJobTitles({ commit }) {
            const url = '/support/job-titles';
            axiosGet(url).then(res => {
                commit('SET_JOB_TITLES', res.data);
            });
        },
        getPayrollPeriods({ commit }) {
            const url = '/support/payroll-periods';
            axiosGet(url).then(res => {
                commit('SET_PAYROLL_PERIODS', res.data);
            });
        },
    },

    mutations: {
        SET_LOCATIONS(state, locations) {
            state.locationList = locations;
        },
        SET_BANKS(state, banks) {
            state.bankList = banks;
        },
        SET_DEPARTMENTS(state, departments) {
            state.departmentList = departments;
        },
        SET_CATEGORIES(state, categories) {
            state.categoryList = categories;
        },
        SET_WORKING_SHIFTS(state, workingShifts) {
            state.workingShiftList = workingShifts;
        },
        SET_EMPLOYEES(state, employees) {
            state.employeeList = employees;
        },
        SET_LEAVE_TYPES(state, leaveTypes) {
            state.leaveTypeList = leaveTypes;
        },
        SET_JOB_TITLES(state, jobTitles) {
            state.jobTitleList = jobTitles;
        },
        SET_PAYROLL_PERIODS(state, payrollPeriods) {
            state.payrollPeriodList = payrollPeriods;
        },
    }
}
